// @flow

import type { Saga } from 'redux-saga';
import { takeLatest, put, call, select } from 'redux-saga/effects';
import WebPushNotificationsApi from '~/sdk/notifications/webPush/ApiNotifications';
import clientConfig from '~/../parameters/client/config';
import { getVerticalId, getCountryCode } from '~/common/selectors/config';
import {
  deleteSearchNotificationSuccess,
  deleteSearchNotificationError,
  closeSearchNotificationConfirmDeleteModal,
} from './actions';
import { DELETE_SEARCH_NOTIFICATION_REQUEST } from './actionTypes';
import { requestedDeleteSearchNotificationSelector } from './selectors';
import { searchNotificationsSelector } from '../SearchNotifications/selectors';
import { openSnackbarError, closeSnackbar } from '../Snackbar/actions';
import { subscriptionIdSelector } from '../Authentication/selectors';
import { trackingCodeByOriginSelector } from '../selectors';

const webPushNotificationsApi = new WebPushNotificationsApi(clientConfig.notificationApi);

export function* deleteSearchNotificationSaga(): Saga<void> {
  yield put(closeSnackbar());

  const searchNotification = yield select(requestedDeleteSearchNotificationSelector);
  const searchNotifications = yield select(searchNotificationsSelector);

  yield put(deleteSearchNotificationSuccess(searchNotification));
  yield put(closeSearchNotificationConfirmDeleteModal());

  const subscriptionId = yield select(subscriptionIdSelector);
  const verticalId = yield select(getVerticalId);
  const countryCode = yield select(getCountryCode);
  const trackingCode = yield select(trackingCodeByOriginSelector);

  const options = {
    subscriptionId,
    searchNotificationId: searchNotification.id,
    verticalId,
    countryCode,
    trackingCode,
  };

  try {
    yield call(
      [webPushNotificationsApi, webPushNotificationsApi.deleteSearchNotification],
      options
    );
  } catch (error) {
    yield put(openSnackbarError());
    yield put(deleteSearchNotificationError(searchNotifications));
  }
}

export default function* sagas(): Saga<void> {
  yield takeLatest(DELETE_SEARCH_NOTIFICATION_REQUEST, deleteSearchNotificationSaga);
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/DeleteSearchNotification/sagas.js